import React, { useEffect, useState } from "react";
import Dialog from "../../../controls/Dialog";
import { TextareaAutosize } from "@material-ui/core";
import { ProgressBar } from "../../../controls";
import RouteOption from "./RouteOption";

const RouteSelector = (props, legs) => {
  const {SystemData} = props;
  const eventBus = SystemData.eventBus;

  const [dialogStates, setDialogStates] = useState({
    showDialog: false,
    options: null,
    status: '',
    progress: null
  });

  useEffect(()=> {
    const open = async (params) => {
      setDialogStates(
        {
          ...dialogStates,
          showDialog:true,
          options: params.options,
          status: params?.status||'',
          progress: params?.progress||null,
          legsExist: params?.legsExist
        }
      );
    }
    eventBus.bind("RouteSelector.open", open);

    return () => {
      eventBus.unbind("RouteSelector.open", open);
    }
  }, [dialogStates, eventBus]);

  const handleSelect = (option) => {
    if (!dialogStates.legsExist) {
      if (props.onChange) {
        props.onChange(option);
      }
      setDialogStates({...dialogStates, showDialog: false, options: null, status: "", progress: null});
      return;
    }
    SystemData.confirm(
      "Replace Route",
      `Please note continuing will remove all legs, costing and revenue data, do you wish to continue?`,
      [
        {icon: "check_circle_outline", value: true, label: "Yes", options: {color:"primary"}},
        {icon: "cancel", value: false, label: "No", options: {color:"secondary"}}
      ],
      (response) => {
        if (response) {
          if (props.onChange) {
            props.onChange(option);
          }
          setDialogStates({...dialogStates, showDialog: false, options: null, status: "", progress: null});
        }
      }
    );
  }

  if (dialogStates.showDialog) {
    return (
      <Dialog 
        open={dialogStates.showDialog}
        title="Suggested Routes"
        message="Below are some possible routes that may be used, please note selecting a route will remove all legs, costing and revenue data:"
        buttons={{
          cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
        }}
        onChange={(state) => {
          setDialogStates({...dialogStates, showDialog: false, options: null, status: "", progress: null});
        }}
        maxWidth={770}
      >
        {dialogStates.status === 'DONE' && Array.isArray(dialogStates.options) ?
        <div>
          {dialogStates.options.map((option) => (
            <RouteOption option={option} onClick={handleSelect}/>
          ))}
        </div>
        : dialogStates.status === 'BUILDING' ?
           <div style={{textAlign: "center"}}>
              <TextareaAutosize minRows={12} style={{width: "95%"}}>
                {dialogStates.progress?.progressText||'...'}
              </TextareaAutosize>
              <div style={{width: "95%", marginLeft: 10}}>
                <ProgressBar completed={dialogStates.progress?.completed||0} backgroundColor={"rgba(255, 128, 0, 1)"} containerStyle={{width: '100%'}}/>
              </div>
           </div> 
        : <div>...</div>}
      </Dialog>
    );  
  }
  return null;
}

export default RouteSelector;